var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.iconType, {
    tag: "component",
    attrs: { type: _vm.iconName, color: _vm.iconColor, size: _vm.iconSize },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }